export default __webpack_public_path__ + "static/adrian-30472219f6fce3c03aa6da26bc029e1a.png";